if (jQuery.browser.msie) {
    document.createElement('selectize'); //to make IE8 happy
}

// angular wrapper for jquery selectize plugin
angular.module('components.selectize', [])
    .directive('selectize', ['$parse', '$interpolate', function ($parse, $interpolate) {

        var defaults = {
            highlight: false,
            dropdownParent: 'body',
            plugins: []
        };
        
        return {
            restrict: 'EA',
            require: ['selectize', '?ngModel'],
            controller: ['$scope', '$attrs', function ($scope, $attrs) {
                var self = this,
                    valueField = $attrs.valueField;

                self.loadOptions = function (options) {
                    self.selectize.clearOptions();
                    self.selectize.load(function(callback) {
                        callback(options);
                    });
                    var model = $scope.$eval($attrs.ngModel);
                    self.updateValues(model);
                };

                self.updateModel = function(value) {

                    var update = function() {
                        var model = self.ngModel.$modelValue;
                        var newValue;

                        if (angular.isArray(model)) {
                            var items, values = self.selectize.items,
                                options = self.selectize.options;
                            if (valueField && ($attrs.ngModel.lastIndexOf("." + valueField) < 0)) {
                                items = [];
                                for (var i = 0; i < values.length; i++) {
                                    var dataKey = values[i];
                                    items.push(options[dataKey]);
                                }
                            } else {
                                items = values;
                            }
                            newValue = items;
                        } else if (angular.isObject(model)) {
                            var item = self.selectize.items[0] || '';
                            newValue = self.selectize.options[item] || {};
                        } else {
                            newValue = self.selectize.getValue();
                        }

                        self.ngModel.$setViewValue(newValue);
                    };

                    if (self.$updating) return;
                    self.$updating = true;
                    try {
                        if ($scope.$$phase) {
                            update();
                        } else {
                            $scope.$apply(update);
                        }
                    }
                    finally
                    {
                        self.$updating = false;
                    }
                };

                self.updateValues = function(newValue) {
                    if (self.$updating) return;
                    self.$updating = true;
                    try {
                        var value = null, options = self.selectize.options;

                        if (valueField && ($attrs.ngModel.lastIndexOf("." + valueField) > 0)) {
                            self.selectize.setValue(newValue);
                        } else if (angular.isArray(newValue)) {
                            for (var i = 0; i < newValue.length; i++) {
                                value = newValue[i][valueField] || newValue[i];
                                if (!options.hasOwnProperty(value)) {
                                    self.selectize.addOption(newValue[i]);
                                }
                                self.selectize.addItem(value);
                            }
                        } else if (angular.isObject(newValue)) {
                            value = newValue[valueField];
                            if (angular.isDefined(value)) {
                                if (!options.hasOwnProperty(value)) {
                                    self.selectize.addOption(newValue);
                                }

                                self.selectize.addItem(value);
                            }
                        } else {
                            self.selectize.setValue(newValue);
                        }
                    } finally {
                        self.$updating = false;
                    }
                };

                self.getOptions = function (query, callback) {
                    if (!query.length || query.length < self.minQueryLength) {
                        return callback();
                    }

                    var getterFn = self.onquery($scope);

                    if ( !$scope.$$phase ) {
                        $scope.$apply(function() {
                            getterFn(query).then(function(results) {
                                callback(results);
                            }, function(error) {
                                callback();
                            });
                        });
                    } else {
                        callback();
                    }
                };

                if ($attrs.options) {
                    $scope.$watchCollection($attrs.options, self.loadOptions);
                }

                if ($attrs.ngModel) {
                    $scope.$watch($attrs.ngModel, self.updateValues);
                }

                self.selectize = null;
                self.$updating = false;
            }],
            compile: function compile(tElem, tAttrs) {

                var options = defaults;

                angular.extend(options, {
                    mode: angular.isDefined(tAttrs.mode) ? tAttrs.mode : undefined,
                    delimiter: angular.isDefined(tAttrs.delimiter) ? tAttrs.delimiter : undefined,
                    highlight: angular.isDefined(tAttrs.highlight) ? Boolean(tAttrs.highlight) : undefined,
                    persist: angular.isDefined(tAttrs.persist) ? Boolean(tAttrs.persist) : undefined,
                    openOnFocus: angular.isDefined(tAttrs.openOnFocus) ? Boolean(tAttrs.openOnFocus) : undefined,
                    maxOptions: angular.isDefined(tAttrs.maxOptions) ? Number(tAttrs.maxOptions) : undefined,
                    maxItems: angular.isDefined(tAttrs.maxItems) ? Number(tAttrs.maxItems) : undefined,
                    hideSelected: angular.isDefined(tAttrs.hideSelected) ? Boolean(tAttrs.hideSelected) : undefined,
                    scrollDuration: angular.isDefined(tAttrs.scrollDuration) ? Number(tAttrs.scrollDuration) : undefined,
                    valueField: tAttrs.valueField,
                    optgroupValueField: tAttrs.optgroupValueField,
                    labelField: tAttrs.labelField,
                    optgroupLabelField: tAttrs.optgroupLabelField,
                    optgroupField: tAttrs.optgroupField,
                    sortField: tAttrs.sortField,
                    sortDirection: tAttrs.sortDirection,
                    searchField: angular.isDefined(tAttrs.searchField) ? tAttrs.searchField.split(',') : [tAttrs.labelField || 'text']
                });

                if (tAttrs.optionTemplate) {
                    options.render = {
                        optionTpl: tAttrs.optionTemplate,
                        option: function (item) {
                            var tplFn = $interpolate(options.render.optionTpl);
                            var html = tplFn(item);
                            return '<div>' + html + '</div>';
                        }
                    };
                }

                if (options.mode === 'multi' || options.maxItems > 1) {
                    options.plugins.push('remove_button');
                }


                return function postLink(scope, element, attrs, ctrls) {
                    var selectCtrl = ctrls[0],
                        ngModelCtrl = ctrls[1];

                    if (ngModelCtrl) {
                        selectCtrl.ngModel = ngModelCtrl;
                        options.onChange = selectCtrl.updateModel;
                    }

                    if (attrs.onquery) {
                        selectCtrl.onquery = $parse(attrs.onquery);
                        options.load = selectCtrl.getOptions;
                        selectCtrl.minQueryLength = options.minQueryLength = angular.isDefined(attrs.minQuery) ? Number(attrs.minQuery) : 1;
                    }

                    element.selectize(options);
                    selectCtrl.selectize = element[0].selectize;

                    element.on('$destroy', function () {
                        selectCtrl.selectize.destroy();
                    });
                };
            }
        };
    }]);